export default {
  containers: {
    location_info: 'Locatie-info',
    attributes: 'Kenmerken',
    links: 'Links',
  },
  labels: {
    title: 'Titel',
    phone_number: 'Telefoonnummer',
    description: 'Beschrijving',
    website: 'Website',
    address: 'Adres',
    regular_hours: 'Reguliere openingstijden',
    page_urls: "Pagina-URL's",
    monday: 'Maandag',
    tuesday: 'Dinsdag',
    wednesday: 'Woensdag',
    thursday: 'Donderdag',
    friday: 'Vrijdag',
    saturday: 'Zaterdag',
    sunday: 'Zondag',
    twenty_four_hours: '24u',
    open_24_hours: '24 uur open',
    open_time: 'Openingstijd',
    close_time: 'Sluitingstijd',
    url: 'URL',
    provider_type: 'Providertype',
    provider_types: {
      merchant: 'Merchant',
      aggregator: 'Aggregator',
    },
    place_action_type: 'Type',
    is_preferred: 'Voorkeur',
    place_action_types: {
      appointment: 'Afspraak boeken',
      online_appointment: 'Online afspraak boeken',
      dining_reservation: 'Reserveringslink',
      food_ordering: 'Eten bestellen voor bezorging en/of afhalen',
      food_delivery: 'Bezorglink',
      food_takeout: 'Afhaallink',
      shop_online: 'Winkelen, met bezorging en/of afhalen',
    },
    no_links: 'Geen links beschikbaar voor dit bedrijf',
    url_menu: 'Menulink',
    url_reservations: 'Reserveringslink',
  },
  placeholders: {
    title: 'Titel',
    phone_number: 'Telefoonnummer',
    description: 'Beschrijving',
    website: 'Website',
    address: 'Adres',
    regular_hours: 'Reguliere openingstijden',
    page_urls: "Pagina-URL's",
    address_line_1: 'Adresregel 1',
    postal_code: 'Postcode',
    locality: 'Plaats',
    region_code: 'Regiocode',
    language_code: 'Taalcode',
    select_time: 'Tijd selecteren',
    url: 'URL',
  },
  buttons: {
    submit: 'Verzenden',
    add: 'Toevoegen',
    delete: 'Verwijderen',
    generate_description: 'AI-beschrijving genereren',
  },
  validation: {
    required: 'Dit veld is verplicht',
    invalid_url: 'Ongeldige URL',
  },
  toasts: {
    success: 'Wijzigingen opgeslagen!',
    description_generation_failed: 'Kan geen beschrijving genereren. Probeer het opnieuw.',
  },
};
